export default "__VITE_ASSET__U$chcGD1__"